import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { MapContainer, TileLayer } from 'react-leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStreetView, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeatmapLayer } from 'react-leaflet-heatmap-layer-v3/lib';

//Components 
import MainCard from '../../../../components/MainCard/index';

export default function MapaTermico({ dados, handleVoltar }) {
  //Estado de controle do loading na tela
  const [loading, setLoading] = useState(false);

  //Estado de controle do mapa
  const [map, setMap] = useState(null);

  //Estado de controle da visão de sateleti
  const [viewSatelite, setViewSatelite] = useState(() => false);

  //Função de troca do estado de visão de sateleti
  const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);

  //Estado de controle do ponto central do mapa
  const [location, setLocation] = useState([dados[0].latitude, dados[0].longitude]);

  const heatmapOptions = {
    radius: 20,
    blur: 20,
    maxZoom: 18,
    minOpacity: 0.5,
    maxOpacity: 1
  };

  return (
    <MainCard noCard title={"Mapa Térmico"} >
      <>
        <div className='mb-3'>
          <Button color='secondary' className='text-white' onClick={handleVoltar}>
            <FontAwesomeIcon icon={faArrowLeft} />
            <span className='px-2'> Voltar </span>
          </Button>
        </div>
        <h4 className='text-secondary m-0'>Mapa Térmico de Fiscalizações</h4>
        <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 mb-5 rounded-3 overflow-hidden shadow" >
          <Col md="12" lg="12" className=' m-0 p-0'>
            <MapContainer
              center={location}
              zoom={13}
              ref={map}
              whenCreated={mapRef => setMap(mapRef)}
              style={{ height: "100%", width: "100%", backgroundColor: "#333" }}
            >

              <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>

              <TileLayer
                url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://carto.com/attribution">CARTO</a>'
              />
              {
                viewSatelite
                &&
                <TileLayer
                  url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                  maxZoom={20}
                  subdomains={['mt1', 'mt2', 'mt3']}
                />

              }

              <HeatmapLayer
                points={dados}
                longitudeExtractor={(m) => m.longitude}
                latitudeExtractor={(m) => m.latitude}
                intensityExtractor={(m) => 100}
                {...heatmapOptions}
              />
            </MapContainer>
          </Col>
        </Row>
      </>
    </MainCard>
  )
}